export default __webpack_public_path__ + "static/media/logo-jira.f9c1ddbe.svg";